import { Icon } from "@iconify/react/dist/iconify.js";
import React, { memo, useEffect, useState } from "react";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../config/axios.config";
import { formatPrice, handleError } from "../../utils/functions";
import useCurrency from "../../hooks/useCurrency";
import Preloader from "../../helper/Preloader";

const SampleNextArrow = memo(function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-right" />
    </button>
  );
});

const SamplePrevArrow = memo(function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-left" />
    </button>
  );
});

function Plans() {
  const { t } = useTranslation();
  const [currency] = useCurrency();
  const [isLoading, setIsLoading] = useState(true);
  const [plans, setPlan] = useState([]);

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance.get("/seller/plan");
        if (!data.error) {
          setPlan(data.data);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    };
    getData();
  }, []);

  const settings = {
    dots: false,
    arrows: true,
    speed: 1000,
    slidesToShow: 3.1,
    slidesToScroll: 1,
    loop: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 3.1,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 3.2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div>
      <Preloader isLoading={isLoading} />
      <section className="pack">
        <div className="container">
          <div className="row">
            <div className="col text-center mb-5">
              <h1>{t("plans.title")}</h1>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              <div className=" arrow-style-two">
                <Slider {...settings}>
                  {plans.map((plan, index) => (
                    <div key={index} className="card-p">
                      <div>
                        <h3>{plan.title}</h3>
                        <h4>
                          <span>{formatPrice(plan.price, currency)}</span>&nbsp; {plan.period}
                        </h4>
                        <p className="mb-22">{plan.description}</p>
                        <h6 className="text-20 mb-6">Plan Features</h6>
                        <ul className="card-1 mb-40">
                          {plan.features.map((feature, idx) => (
                            <li key={idx}>
                              <Icon icon="tabler:copy-check-filled" />
                              <span>{feature}</span>
                            </li>
                          ))}
                        </ul>
                        <a
                          href={`https://argetem-seller-rzevk.ondigitalocean.app/payment?plan=${plan._id}`}
                          className="btn btn-main-two w-100 py-16 fw-medium d-inline-flex align-items-center justify-content-center gap-8"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Buy Now
                          <span className="icon text-xl d-flex">
                            <i className="ph ph-arrow-right"></i>
                          </span>
                        </a>
                        <div className="text-center">
                          <span className="text-center mb-0">{plan.planFor}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Plans;
